import * as React from 'react';
import { Spinner } from 'rcd-cpp-ui/ui/loader';
import { Dropdown } from './../Dropdown/dropdown';
import { ThreeDots } from './../Icon/icon';
import './actionMenu.scss';
import { MenuAction } from '../../types/MenuActions';

enum Actions {
  accept = 'Accept',
  makePrimary = 'Make Primary'
}
type Keys = keyof typeof Actions;

type Props = { [key in Keys]?: MenuAction };

export const ActionMenu = (actions: Props) => {
  const [isLoading, setLoading] = React.useState(false);
  const options = Object.entries(Actions).reduce((opts, [key, name]) => {
    if (actions[key]) opts.push({ key, name });
    return opts;
  }, []);
  if (!options.length) return null;
  return (
    <div className="action-menu">
      {isLoading && <Spinner spinnerSize="icon" />}
      {!isLoading && (
        <Dropdown
          options={options}
          position="right"
          renderOption={o => (
            <div>
              <span className="dd-text" data-txt={o.name}>
                {o.name}
              </span>
            </div>
          )}
          onSelect={async o => {
            const action = actions[o.key] as MenuAction;
            if (!action) return;
            action({ setLoading });
          }}
        >
          <ThreeDots />
        </Dropdown>
      )}
    </div>
  );
};
